var map = {
	"./actualidad.json": 444,
	"./area.json": 6559,
	"./artista.json": 9940,
	"./butaca.json": 1808,
	"./comun.json": 8068,
	"./contacto.json": 359,
	"./donar.json": 8260,
	"./envio.json": 7925,
	"./errores.json": 7768,
	"./legal.json": 8675,
	"./marco.json": 540,
	"./piezas.json": 7718,
	"./portada.json": 7003,
	"./puerta.json": 7613,
	"./radar.json": 4726,
	"./radio.json": 7541,
	"./rail.json": 5474,
	"./sobre.json": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 743;